const langConstant = {
  EN: 'en'
}

export default langConstant;